import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import SaleOrRent from '../SaleOrRent/index';

class ProductionFeatures extends Component {
  render() {
    const { features, loading } = this.props;
    return (
      <Fragment>
        <div className="col-md-4 pb-10">
          <ReactPlaceholder showLoadingAnimation rows={1} type="text" ready={!loading}>
            <SaleOrRent name="Escenografía/Sets" value={features.sets} />
          </ReactPlaceholder>
        </div>
        <div className="col-md-4 pb-10">
          <ReactPlaceholder showLoadingAnimation rows={1} type="text" ready={!loading}>
            <SaleOrRent name="Vestuario/Costumes" value={features.costumes} />
          </ReactPlaceholder>
        </div>
        <div className="col-md-4 pb-10">
          <ReactPlaceholder showLoadingAnimation rows={1} type="text" ready={!loading}>
            <SaleOrRent name="Sobretítulos/Titles" value={features.titles} />
          </ReactPlaceholder>
        </div>
        <div className="col-md-4 pb-10">
          <ReactPlaceholder showLoadingAnimation rows={1} type="text" ready={!loading}>
            <SaleOrRent name="Utilería/Props" value={features.props} />
          </ReactPlaceholder>
        </div>
        <div className="col-md-4 pb-10">
          <ReactPlaceholder showLoadingAnimation rows={1} type="text" ready={!loading}>
            <SaleOrRent name="Orquestación/Orchestration" value={features.orchestration} />
          </ReactPlaceholder>
        </div>
      </Fragment>
    );
  }
}

ProductionFeatures.defaultProps = {
  loading: true,
};

ProductionFeatures.propTypes = {
  loading: PropTypes.bool,
  features: PropTypes.array.isRequired,
};

export default ProductionFeatures;



// WEBPACK FOOTER //
// ./src/components/Production/ProductionFeatures.js